import { Box, styled } from '../../base';

export const JobEntityWrapperBox = styled(Box)(({ theme }) => ({
    paddingTop: theme.spacing(3),
    paddingInlineStart: theme.spacing(5),
    paddingInlineEnd: theme.spacing(4),
}));

export const JobEntityBox = styled(Box)(({ theme }) => ({
    backgroundColor: theme.palette.background.paper,
    borderRadius: theme.spacing(1),
    padding: '40px',
}));
